<!--
 * @Author: xing.huang
 * @Date: 2021-11-01 16:52:20
 * @LastEditTime: 2023-03-06 14:36:54
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\alarm\ExceptionList\index.vue
 * 
-->
<template>
  <div class="exception-list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="我的清单" name="1" style="margin-left:20px"></el-tab-pane>
      <el-tab-pane label="关注的清单" name="2"> </el-tab-pane>

      <el-card class="table_searchbar">
        <el-row :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="5">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">事件名称：</span>
              <el-select style="max-width:200px" multiple collapse-tags filterable size="small" v-model="searchForm.eventName" maxlength="16" placeholder="请选择">
                <el-option v-for="item in eventList" :key="item.name" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">状态：</span>
              <el-select style="max-width:180px" multiple collapse-tags filterable size="small" v-model="searchForm.status" maxlength="16" placeholder="请选择">
                <el-option v-if="activeName == 1" v-for="item in statusOptions.filter(item => item.value != 5)" :key="item.value" :label="item.name" :value="item.value"></el-option>
                <el-option v-if="activeName == 2" v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">触发时间：</span>
              <el-date-picker
                size="small"
                style="max-width:220px"
                value-format="yyyy-MM-dd"
                v-model="searchForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">事件编码：</span>
              <el-input size="small" style="max-width:220px" v-model="searchForm.eventCode" end-placeholder="事件编码"></el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="text-align:right">
              <el-button icon="el-icon-search" size="mini" type="primary" @click="btnSearch()">查询</el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="clearSearch">重置</el-button>
              <!-- <el-button  size="mini" @click='addItem' type="primary">新增</el-button> -->
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="table-card">
        <el-table :data="tableData" :default-sort="defaultSort" @sort-change="sortChangeEvent">
          <el-table-column prop="eventCode" label="事件编码" min-width="120"></el-table-column>
          <el-table-column prop="eventName" label="事件名称" min-width="100"></el-table-column>
          <!-- <el-table-column prop="workOrderCode" label="工单号" min-width="100" ></el-table-column>
                    <el-table-column prop="materialCode" label="物料编码" min-width="120" ></el-table-column>
                    <el-table-column prop="materialName" label="物料名称" min-width="120" ></el-table-column> -->
          <el-table-column prop="status" :formatter="parseStatus" label="状态" min-width="100"></el-table-column>
          <el-table-column
            prop="triggerTime"
            sortable="custom"
            :formatter="(row, column, cellValue, index) => $commonUtil.changeToDate(row, column, cellValue)"
            label="触发时间"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="gmtModified"
            sortable="custom"
            :formatter="(row, column, cellValue, index) => $commonUtil.changeToDate(row, column, cellValue)"
            label="最近提交时间"
            min-width="150"
          ></el-table-column>
          <el-table-column prop="submitterName" label="最新提交人" min-width="100"></el-table-column>
          <el-table-column prop="dutyUserName" label="当前执行人" show-overflow-tooltip min-width="140"></el-table-column>
          <el-table-column prop="gmtCreate" label="操作" width="100">
            <template slot-scope="scope">
              <el-button v-if="permission.btn_anomalyEvent_doAction" type="text" @click="handleEdit(scope.row)">{{ activeName == 1 ? "编辑" : "查看" }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page" v-if="tableData.length > 0">
          <div class="total_page">
            <span> 共{{ tableTotalPage }}条 10条/页</span>
          </div>
          <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
            <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
          </div>
        </div>
      </el-card>

      <!-- <el-tab-pane label="已完结清单" name="2"></el-tab-pane> -->
    </el-tabs>
    <add-exception :isAdd="isAdd"></add-exception>
    <edit-exception :isEdit="isEdit" :editInfo="editInfo"></edit-exception>
  </div>
</template>
<script>
import AddException from "./addException.vue";
import EditException from "./editException.vue";
import dayjs from "dayjs";
export default {
  components: { AddException, EditException },
  data() {
    return {
      isAdd: false,
      isEdit: false,
      editInfo: {},
      orderType: "DESC", //排序类型
      orderColumn: "triggerTime", //排序列
      defaultSort: {
        prop: "triggerTime",
        order: "descending"
      }, //默
      tableData: [],
      activeName: "1",
      eventList: [
        { name: "工序逾期开工", type: 1 },
        { name: "工单逾期开工", type: 2 },
        { name: "工序完工逾期", type: 3 },
        { name: "工单完工逾期", type: 4 },
        { name: "在制品呆滞", type: 6 },
        { name: "在制品积压", type: 5 },
        { name: "母卷质量检超时", type: 7 },
        { name: "子卷质量检超时", type: 8 },
        { name: "自检超时", type: 9 },
        { name: "点检延期", type: 10 },
        { name: "其他异常", type: 11 }
      ],
      statusOptions: [
        { name: "待确认", value: 0 },
        { name: "待处理", value: 1 },
        { name: "处理中", value: 2 },
        { name: "待审核", value: 3 },
        { name: "审核中", value: 4 },
        { name: "未通过", value: 6 },
        { name: "已完结", value: 5 }
      ],
      searchForm: {
        tabType: 1,
        eventName: [],
        status: [],
        date: [dayjs(new Date().getTime() - 60 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD"), dayjs(new Date().getTime()).format("YYYY-MM-DD")],
        eventCode: ""
      },
      searchFormTemp: {
        tabType: 0,
        eventName: [],
        status: [],
        date: [dayjs(new Date().getTime() - 60 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD"), dayjs(new Date().getTime()).format("YYYY-MM-DD")],
        eventCode: ""
      },
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      tableTotalPage: 100,
      tableCurrentPage: 1,
      permission: JSON.parse(localStorage.getItem("permission")),
      propertyExtendList: []
    };
  },
  mounted() {
    this.initTable();
    this.getPropertyExtendList();
  },
  methods: {
    async getPropertyExtendList() {
      let { code, data } = await this.$RequestUtil.getAsync({ url: "/api/property-extend/list", type: "sync", params: { type: 0 } });
      data.forEach(item => {
        item.propertyValue = null;
      });
      this.propertyExtendList = data;
      // return data
    },
    async getCustomeValueList(businessOrderSplitId) {
      if (businessOrderSplitId) {
        let { code, data } = await this.$RequestUtil.getAsync({ url: "/api/businessOrderSplitPropertyExtend/listBusinessOrderSplitPropertyExtend", type: "sync", params: { businessOrderSplitId } });
        return data;
      }
      return [];
    },
    async getAllValueList(workOrderId) {
      let res = await this.getCustomeValueList(workOrderId);

      let propertyExtendListCopy = commonUtils.cloneObj(this.propertyExtendList);
      propertyExtendListCopy.forEach(item => {
        let index = res.findIndex(f => f.propertyExtendId == item.id);
        if (index > -1) {
          item.propertyValue = res[index].propertyValue;
          item.isDeleted = res[index].isDeleted;
          item.oldId = res[index].id;
          res.splice(index, 1);
        }
      });
      if (res.length > 0) {
        res.forEach(item => {
          propertyExtendListCopy.push({
            id: item.propertyExtendId,
            propertyName: item.propertyName,
            propertyValue: item.propertyValue,
            oldId: item.id,
            inputType: 0,
            values: [],
            isDeleted: item.isDeleted
          });
        });
      }
      return propertyExtendListCopy;
    },
    //排序改变事件
    sortChangeEvent(param) {
      console.log(param);
      let orderType = param.order;
      let orderColumn = param.prop;
      this.orderColumn = orderColumn;
      if (orderType == "descending") {
        this.orderType = "DESC";
      } else if (orderType == "ascending") {
        this.orderType = "ASC";
      } else {
        this.orderType = orderType;
        this.orderColumn = null;
      }
      this.search(1);
      this.tableCurrentPage = 1;
    },
    search: function() {
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            tabType: 0,
            eventName: [],
            status: "",
            date: [dayjs(new Date().getTime() - 60 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD"), dayjs(new Date().getTime()).format("YYYY-MM-DD")]
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      if (!temp.date || (temp.date && temp.date.length != 2)) {
        this.$message.warning("触发时间不能为空");
        return;
      }
      this.$RequestUtil.get({
        url: "/api/anomalyEvent/list",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: 10,
          tabType: Number(this.activeName),
          eventName: temp.eventName + "",
          status: temp.status + "",
          eventCode: temp.eventCode,
          orderType: this.orderType,
          orderColumn: this.orderColumn,
          startDate: temp.date && temp.date[0] ? temp.date[0] : "",
          endDate: temp.date && temp.date[0] ? temp.date[1] : ""
        },
        success: res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },

    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },

    initTable: function() {
      this.search();
    },

    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.search();
    },

    clearSearch() {
      this.btnPressType = 2;
      this.searchForm.eventName = [];
      this.searchForm.status = [];
      this.searchForm.date = [dayjs(new Date().getTime() - 60 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD"), dayjs(new Date().getTime()).format("YYYY-MM-DD")];
      this.searchForm.eventCode = "";
    },

    addItem() {
      this.isAdd = true;
    },

    async handleEdit(row) {
      this.editInfo = await this.loadDetail(row.id);
      this.editInfo.propertyExtendList = await this.getAllValueList(this.editInfo.workOrderId);
      this.editInfo.materialInfo = this.editInfo.materialName + "|" + this.editInfo.materialCode;
      this.editInfo.deviceInfo = this.editInfo.deviceName + "|" + this.editInfo.deviceCode;
      // this.editInfo.anomalyCode = 'procedure_starts_overdue'
      this.editInfo.dutyUserList = this.editInfo.dutyUserList.map(item => item.userId);
      this.editInfo.dutyUserName = row.dutyUserName;
      let deviceName = "";
      if (this.editInfo.deviceName) {
        deviceName = this.editInfo.deviceName;
      }
      let deviceCode = "";
      console.log(deviceName, 77777, this.editInfo.deviceName, 8888);
      if (this.editInfo.deviceCode != null || this.editInfo.deviceCode != undefined) {
        deviceCode = this.editInfo.deviceCode;
      }
      if (!deviceCode && !deviceName) {
        this.editInfo.deviceInfo = "";
      } else {
        this.editInfo.deviceInfo = deviceName + "|" + deviceCode;
      }
      // this.editInfo.qcTaskCode = row.qcTaskCode
      this.editInfo.fileList = [{ fileId: null, fileUrl: "" }];
      if (this.activeName == "2") {
        this.editInfo.isRead = true;
      }
      this.isEdit = true;
    },

    async loadDetail(id) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: "/api/anomalyEvent/detail", params: { id } });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
      }
    },

    handleClick() {
      this.searchForm.tabType = this.activeName;
      this.search();
    },

    parseEventType(row) {
      return (this.eventList.find(item => item.type == row.eventType) || {}).name;
    },

    parseInfo(row) {
      if (row.eventType == 1 || row.eventType == 3) {
        return row.deviceName + "|" + row.deviceCode;
      } else {
        return row.materialName + "|" + row.materialCode;
      }
    },
    parseStatus(row) {
      return (this.statusOptions.find(item => item.value == row.status) || {}).name;
    }
  }
};
</script>
<style scoped>
.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
}
.page {
  display: flex;
  justify-content: flex-end;
}

.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
.exception-list .el-tabs__item {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  font-family: "MiSans-Regular";
  color: #94a3b8;
}
.exception-list .el-tabs__nav-wrap::after {
  height: 0px;
}
.exception-list .el-tabs__header {
  margin: 0px 20px 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/alarm/ExceptionList/index.vue